"use client";

import { createContext, useContext } from "react";
import { createTableLabelFn, type TableLabelFn } from "../app";

/** Функция подстановки текстов; без провайдера — английские значения по умолчанию. */
export const TableLabelsContext = createContext<TableLabelFn>(createTableLabelFn());

export function useTableLabelFn(): TableLabelFn {
  return useContext(TableLabelsContext);
}
